import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ActionType } from 'typesafe-actions'
import { NAMESPACE } from './constants'
import { TGetOtpRequest, TGetOtpResponse, TSendSmsRequest, TSendSmsResponse } from './types'

/**
 * This slice mints action creators only — its reducer is deliberately not registered in
 * `modules/api/reducer.ts` because neither sending an SMS nor requesting an OTP leaves
 * anything behind that the client needs to read back.
 */
const slice = createSlice({
  name: `${NAMESPACE}Api`,
  initialState: {},
  reducers: {
    sendSms_request: (state, { payload }: PayloadAction<TSendSmsRequest>) => {},
    sendSms_success: (state, { payload }: PayloadAction<TSendSmsResponse>) => {},
    getOtp_request: (state, { payload }: PayloadAction<TGetOtpRequest>) => {},
    getOtp_success: (state, { payload }: PayloadAction<TGetOtpResponse>) => {},
  },
})

const { reducer, actions: events } = slice

export type SmsEvent = ActionType<typeof events>

export { events, reducer }
